import css from './index.module.scss';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/components/ProductComponents';
import TextModule from '@/components/ProductDetailComponents/TextModule';
import TextOnImage from '@/components/ProductDetailComponents/TextOnImage';
import CardModule from '@/components/ProductDetailComponents/CardModule';
import { getImageLocal } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/smartgenerator/pc/');

const textStyle = {
    fontFamily: 'var(--font-family-Bold)',
    fontSize: '64px',
    fontWeight: '700',
    lineHeight: '1.13',
    textAlign: 'center',
    backColor: 'transparent',
    margin: '0 auto',
    color: '#fff',
};

const textStyle2 = {
    fontFamily: 'var(--font-family-SemiBold)',
    fontSize: '22px',
    fontWeight: '600',
    lineHeight: '30px',
    textAlign: 'center',
    backColor: 'transparent',
    margin: '0 auto',
    color: '#919191',
};
export default function IndexDynamic() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { t } = useLang('smartgenerator');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const item = {
        title: '',
        alt: t('smart_generator.third_title'),
        synopsis: t('smart_generator.third_title'),
        desc: t('smart_generator.third_des'),
        bgImgs: ['3_main.webp', '3_main.jpg'],
    };
    const text = {
        text: t('smart_generator.four_title'),
    };

    const text1 = {
        text: t('smart_generator.four_subtitle'),
    };

    const text2 = {
        text: t('smart_generator.four_des'),
    };

    const text3 = {
        text: t('smart_generator.five_title'),
    };

    const text4 = {
        text: t('smart_generator.five_des'),
    };
    const item1 = {
        title: '',
        alt: t('smart_generator.six_alt'),
        synopsis: `<p>${t('smart_generator.six_title')}</p> <p>${t('smart_generator.six_subtitle')}</p>`,
        desc: t('smart_generator.six_des'),
        bgImgs: [`6_main_${imgLocal}.webp`, `6_main_${imgLocal}.png`],
    };

    const synopsisFontSize = {
        us: 64,
        jp: 53,
        cn: 59,
    };

    return (
        <>
            <div className="ytdd">
                <div className="section section1">
                    <h3 className="tit">{t('smart_generator.ytdd_sec1_tit')}</h3>
                    <p className="subtit">{t('smart_generator.ytdd_sec1_subtit')}</p>
                    <div className="bg-img">
                        <EFPic name={['section1.webp', 'section1.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                    </div>
                </div>
                <div className="section section2">
                    <div className="section sec2-sec1">
                        <h3 className="tit">{t('smart_generator.ytdd_sec2-sec1_tit')}</h3>
                        <p className="subtit">{t('smart_generator.ytdd_sec2-sec1_subtit')}</p>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec1.webp', 'sec2-sec1.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                        </div>
                    </div>
                    <div className="section sec2-sec2">
                        <h3 className="tit">{t('smart_generator.ytdd_sec2-sec2_tit')}</h3>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec2.webp', 'sec2-sec2.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                        </div>
                    </div>
                    <div className="section sec2-sec3">
                        <h3 className="tit">{t('smart_generator.ytdd_sec2-sec3_tit')}</h3>
                        <div className="bg-img">
                            <EFPic name={['sec2-sec3.webp', 'sec2-sec3.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                        </div>
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">{t('smart_generator.ytdd_sec3_tit')}</h3>
                    <p className="subtit">{t('smart_generator.ytdd_sec3_subtit')}</p>
                    <div className="bg-img">
                        <EFPic name={['section3.webp', 'section3.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                    </div>
                </div>
                <div className="section section4">
                    <h3 className="tit">{t('smart_generator.ytdd_sec4_tit')}</h3>
                    <p className="subtit">{t('smart_generator.ytdd_sec4_subtit')}</p>
                    <div className="bg-img">
                        <EFPic name={['section4.webp', 'section4.jpg']} className="fullImgs" alt={t('Smart Generator')} />
                    </div>
                </div>
            </div>
            <div className="textOnImg1">
                <TextOnImage
                    data={item}
                    config={{
                        position: 'top',
                        synopsisColor: '#fff',
                        descColor: 'rgba(246, 246, 248, 0.6)',
                        titleFontSize: '32',
                        synopsisFontSize: locale === 'de' ? 52 : 64,
                        synopsisLineHeight: locale === 'fr' ? 1.3 : 1.13,
                        descFontSize: '22',
                        webpUrl: '/media/smartgenerator/pc/',
                    }}
                />
            </div>
            <LineSpace height={120} background="transparent" />
            <div className={css.compare}>
                <div className="compare-left">
                    <div className="compare-digital">+25%</div>
                    <div className="compare-digital-text">{t('smart_generator.four_charging_efficiency')}</div>
                </div>
                <div className="compare-right">
                    <div className="compare-progress">
                        <div className="compare-progress-item">
                            <div className="progress-text">{t('smart_generator.four_smart_generator')}</div>
                            <div className="progress-bar bar1"></div>
                        </div>

                        <div className="compare-progress-item">
                            <div className="progress-text">{t('smart_generator.four_other_generators')}</div>
                            <div className="progress-bar bar2"></div>
                        </div>
                        <LineSpace height={47} background="transparent" />
                        <div className="compare-annotation">{t('smart_generator.four_charging_des')}</div>
                    </div>
                </div>
            </div>
            <LineSpace height={180} background="transparent" />
            <TextModule data={text} cssStyle={textStyle} />
            <TextModule data={text1} cssStyle={textStyle} />
            <LineSpace height={34} background="transparent" />
            <div className="textModule1">
                <TextModule data={text2} cssStyle={textStyle2} />
            </div>
            <LineSpace height={88} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '1120px',
                    height: '630px',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['4_main.webp', '4_main.jpg']} className="fullImgs" alt={t('smart_generator_recharge')} />
            </div>
            <LineSpace height={180} background="transparent" />
            <TextModule data={text3} cssStyle={textStyle} />
            <LineSpace height={40} background="transparent" />
            <div className="textModule2">
                <TextModule data={text4} cssStyle={textStyle2} />
            </div>
            <LineSpace height={89} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '1120px',
                    height: '630px',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['5_main.webp', '5_main.jpg']} className="fullImgs" alt={t('smart_generator_safety')} />
            </div>
            <LineSpace height={140} background="transparent" />
            <div className="textOnImg2">
                <TextOnImage
                    data={item1}
                    config={{
                        position: locale == 'sa' ? 'right' : 'left',
                        titleColor: '#ededed',
                        synopsisColor: '#fff',
                        descColor: '#999',
                        synopsisFontSize: synopsisFontSize[locale] || synopsisFontSize.us,
                        descFontSize: '22',
                        iconWidth: '115',
                        iconHeight: '33',
                        itemsColor: '#fff',
                        webpUrl: '/media/smartgenerator/pc/',
                    }}
                />
            </div>
            <LineSpace height={180} background="transparent" />
            <div className="cardModule1">
                <CardModule
                    cssStyle={{
                        backColor: '#000',
                        titleStyle: {
                            margin: '0 0 90px 0',
                        },
                        webpUrl: '/media/smartgenerator/pc/',
                    }}
                    data={{
                        items: [
                            {
                                title: '',
                                desc: `<span style="font-size: ${locale === 'fr' ? '19px' : '22px'}">${t(
                                    'smart_generator.seven_left_gray_des',
                                )}</span><span style="color: #fff;font-size: ${locale === 'fr' ? '19px' : '22px'}">${t(
                                    'smart_generator.seven_left_white_des',
                                )}</span>`,
                                url: ['7_card_1.webp', '7_card_1.png'],
                                alt: 'smart_generator_hassle_to_maintain',
                            },
                            {
                                title: '',
                                desc: `<span style='color: #fff;font-size: ${locale === 'fr' ? '19px' : '22px'}'>${t(
                                    'smart_generator.seven_right_white_des',
                                )}</span>
                            <span style="font-size: ${locale === 'fr' ? '19px' : '22px'}">${t('smart_generator.seven_right_gray_des')}</span>`,
                                url: ['7_card_2.webp', '7_card_2.png'],
                                alt: 'smart_generator_LCD_easy_to_check',
                            },
                        ],
                        textGuide: '',
                        textTitle: t('smart_generator.seven_title'),
                        textDesc: '',
                    }}
                />
            </div>
            <LineSpace height={150} background="transparent" />
            <OtherList
                theme="black"
                data={getDetaileMoreProducts(gloproductlist, [
                    'product_ps_river_river_pro_720',
                    'product_ps_delta_max_smart_extra_battery',
                    'product_ps_delta_delta_pro',
                ])}
            />
        </>
    );
}
